export default __webpack_public_path__ + "static/media/middle-line.af2adec7.svg";